import { ThemeFactory } from "../../../lib/theming/ThemeFactory";
export var getModalTheme = function getModalTheme(contextTheme, propsTheme) {
  if (propsTheme === void 0) {
    propsTheme = {};
  }

  var theme = ThemeFactory.create(propsTheme, contextTheme);
  return ThemeFactory.create(propsTheme, ThemeFactory.create({
    loaderBorderRadius: theme.modalBorderRadius
  }, theme));
};